<div class="pinch-zoom-content">
	<ng-content></ng-content>
</div>
